define 'controller/NavigationController', ['jquery', 'custom/media-query'], ($, mq) ->
  class Navigation

    constructor: (@$el) ->
      container = @$el
      self = this
      @$navigationListClose = @$el.find('.navigation__list__close')

      $(container).on 'mouseenter', '.navigation:not(.active) .navigation__list__item--mainCategory', (e) ->
        if $(@).hasClass('navigation__list__item--mainCategory--no-flyout')
          return
        $(@).find('.sub-navigation__list__flyout').stop().fadeIn(0.1)
 
      $(container).on 'mouseleave', '.navigation:not(.active) .navigation__list__item--mainCategory', (e) ->
        if $(@).hasClass('navigation__list__item--mainCategory--no-flyout')
          return
        $(@).find('.sub-navigation__list__flyout').stop().fadeOut(0.1)

      $('.navigation__close').on 'click', (e) ->
        $(@).closest('.sub-navigation__list__flyout').stop().fadeOut(0.1)

      $('.mobile-navigation__open').on 'click', (e) ->
        $('.navigation').addClass('active')
        self.$navigationListClose.addClass('active')
        $('body').addClass('navOpen')
        $('.darkOverlay').addClass('active')

      self.$navigationListClose.on 'click', (e) ->
        self._closeNavigation()

      $('.js-close-mobilenav').on 'click', (e) ->
        self._closeNavigation()

      $('.darkOverlay').on 'click', (e) ->
        self._closeNavigation()

      $(container).on 'click', '.navigation.active .navigation__list__item--mainCategory a.hasChildren, .navigation.active .navigation__list__item--mainCategory span.hasChildren', (e) ->
        if mq.up_to_L
          e.preventDefault()
          if $(@).closest('[data-navigation]').data('navigation') == 'right'
            $('.navigation__list.navigation__list--left').hide()
          $(@).parent().find('.sub-navigation__list__flyout').addClass('selected')
          $(@).closest('.navigation__inner').addClass('selected')

      $(container).on 'click', '.navigation.active .sub-navigation__list__flyout--childCategory a.hasChildren, .navigation.active .sub-navigation__list__flyout--childCategory span.hasChildren', (e) ->
        e.preventDefault()
        $(@).toggleClass('active')
        $(@).next().slideToggle('slow')

      $(container).on 'click', '.sub-navigation__list__flyout--back', (e) ->
        $('.navigation__list.navigation__list--left').show()
        $(@).closest('.navigation__inner').removeClass('selected')
        setTimeout (->
          $('.sub-navigation__list__flyout').removeClass('selected')
        ), 500

      if !$("body").hasClass("full-width")
        $('.sub-navigation__list__flyout').css('width', $('.pagecontent').width())

        $(window).on 'resize', (e) ->
          $('.sub-navigation__list__flyout').css('width', $('.pagecontent').width())

      $('[data-t-navi-cat-link]').on "click" , (e) ->
        $el = $(e.currentTarget)
        if !$el.hasClass('hasChildren') || mq.XL_and_up
          e.preventDefault()
          e.stopPropagation()
          $el = $(e.currentTarget)
          href = $el.attr('href')
          target = $el.data('url')
          data = $el.data('datalayer-category-selection')
          try
            dataLayer.push(JSON.parse(decodeURIComponent(escape(atob(data)))))
          catch exception
            try
              dataLayer.push(JSON.parse(atob(data)))
            catch ignored

          if(target && target.length > 0)
            window.location = window.atob(target)
          else
            window.location = href

    _closeNavigation: ->
      $('.navigation').removeClass('active')
      @$navigationListClose.removeClass('active')
      $('body').removeClass('navOpen')
      $('.darkOverlay').removeClass('active')

    destroy: ->
      @$el.off()